import domReady from '../helpers/dom-ready';

class ExhibitionLanguageSwitcher {
  static init() {
    return new ExhibitionLanguageSwitcher();
  }

  constructor() {
    const exhibitionHeader = document.querySelector('.exhibition-header');
    if (!exhibitionHeader) { return; }

    this.languageSwitcher = exhibitionHeader.querySelector('.language-switcher > select');
    if (!this.languageSwitcher) { return; }

    this.languageSwitcher.addEventListener('change', () => {
      const option = this.languageSwitcher.options[this.languageSwitcher.selectedIndex];

      if (option && option.value) {
        if (option.dataset.slug && window.pll_set_current_language) {
          window.pll_set_current_language(option.dataset.slug);
        }

        window.location.href = option.value;
      }
    });
  }
}

domReady(() => {
  ExhibitionLanguageSwitcher.init();
});
